import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import Skeleton from "@mui/material/Skeleton"

import { times } from "ramda"

export function SkeletonList() {
  return (
    <List>
      {times(
        () => (
          <ListItem>
            <ListItemText primary={<Skeleton animation="wave" />} />
          </ListItem>
        ),
        5,
      )}
    </List>
  )
}
